// frontend/src/components/dashboard/Dashboard.js

import React from "react";
import DashboardRouter from "./DashboardRouter";

/*
 * R5 — Dashboard.js becomes a thin router.
 *
 * The previous Dashboard implementation is preserved and continues to
 * work as an SR-view fallback if something goes wrong with the new
 * dashboard. But since R5 replaces the visual with a role-aware view,
 * we now delegate to DashboardRouter.
 *
 * If you need to roll back the visual change without touching anything
 * else, change this file back to the pre-R5 version.
 */

function Dashboard() {
  return <DashboardRouter />;
}

export default Dashboard;